import * as React from 'react'
import DashboardIcon from '@mui/icons-material/Dashboard'
import StoreIcon from '@mui/icons-material/Store'
import UserIcon from '@mui/icons-material/People'
import CategoryIcon from '@mui/icons-material/Category'
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import useOrdersMenu from './useOrdersMenu'
import AuthStorage from '../../services/authStorage'

const Auth = new AuthStorage();

export default function useDefaultMenuConfig() {
  const ordersMenu = useOrdersMenu();

  const menu = [
    { icon: <DashboardIcon />, title: 'Dashboard', to: '/admin', extraLinks: ['/admin/dashboard'], items: [] },
    ordersMenu,
    { icon: <StoreIcon />, title: 'Stores', to: '/admin/stores', active: false },
    {
      icon: <CategoryIcon />,
      title: 'Products',
      open: false,
      items: [
        { title: 'Products', to: '/admin/products', active: false },
        { title: 'Inventory', to: '/admin/inventory', active: false },
        { title: 'Categories', to: '/admin/categories', active: false },
        { title: 'Collections', to: '/admin/collections', active: false }
      ]
    },
    {
      icon: <LocalShippingIcon />,
      title: 'Fulfillment',
      open: false,
      items: [
        { title: 'Fulfillment Centers', to: '/admin/fulfillment-centers', active: false },
        { title: 'Fulfillment Orders', to: '/admin/fulfillment-center-orders', active: false }
      ]
    }
  ];

  if (Auth.getUser()?.role === global.constants.userRoles.superAdmin) {
    menu.push({ icon: <UserIcon />, title: 'Users', to: '/admin/users', active: false });
  }

  return menu;
}